<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" style="calc(100% - 0px)" center
        :close-on-click-modal="false" :before-close="handleClose">
        <div>
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="">
                    <el-upload ref="upload" action="" :limit="1" accept=".xls" :disabled="isUploading"
                        :auto-upload="false" :on-change="beforeUpload">
                        <el-button size="small" type="primary">选择.xls文件</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <el-table size="small" height="calc(90vh - 400px)" border row-key="id" :data="tableData"
                v-loading="loadingPage" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
                <el-table-column fixed min-width="100" prop="mac" label="设备MAC"></el-table-column>
                <el-table-column min-width="100" prop="cloud" label="云"></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <span style="color: blue;" @click="handleImportDelete(scope.row)">删除</span>
                    </template>
                </el-table-column>
            </el-table><br />
            <span slot="footer">
                <el-button size="small" type="primary" @click="handleImportXls">保存</el-button>
            </span>
        </div>
    </el-dialog>
</template>
<script>
import * as XLSX from 'xlsx/xlsx.mjs';

export default {
    components: {

    },
    name: 'import_xls',
    data() {
        return {
            loadingPage: false,
            dialogVisible: false,
            dialogTitle: '',
            formInline: {
                mac: '',
                cloud: '',

                page: 1,
                limit: 999
            },
            tableData: [],
            isUploading: false,
        }

    },
    methods: {
        handleClose() {
            this.dialogVisible = false
            this.loadingPage = false
        },
        importFlagFn(data, flag) {
            this.dialogVisible = true
            this.dialogTitle = flag
        },
        beforeUpload(file, files) {
            console.log(files)
            this.analysisExcel(file.raw).then((tableJson) => {
                if (tableJson && tableJson.length > 0) {
                    let dataExcel = tableJson[0];
                    this.tableData = JSON.parse(JSON.stringify(dataExcel.sheet))
                }
            });
        },
        analysisExcel(file) {
            return new Promise(function (resolve, reject) {
                const reader = new FileReader();
                console.log(reject)
                reader.onload = function (e) {
                    const data = e.target.result;
                    let datajson = XLSX.read(data, {
                        type: "binary",
                    });
                    const result = [];
                    datajson.SheetNames.forEach((sheetName) => {
                        result.push({
                            sheetName: sheetName,
                            sheet: XLSX.utils.sheet_to_json(datajson.Sheets[sheetName]),
                        });
                    });
                    resolve(result);
                };
                reader.readAsBinaryString(file);
            });
        },
        handleImportXls() {
            if (this.tableData.length == 0) {
                this.$message.warning('请导入配置数据!!!')
                return
            }
            let param={
                tableData: this.tableData
            }
            this.loadingPage=true
            this.$http['post']('remote_log_devices_import/', param, res=>{
                this.loadingPage=false
                if(res.data.code==200){
                    this.handleClose()
                    this.$message.success(res.data.msg)
                    this.$emit('refreshData')
                }else{
                    this.$message.warning(res.data.msg)
                }
            })
        },
        handleImportDelete(row){
            this.tableData = this.tableData.filter(item => item.mac !== row.mac && item.cloud !== row.cloud)
        }
    },
    created() {

    }
}
</script>
<style>
span:hover {
    cursor: pointer;
}
</style>